(function () {
  'use strict';

  var PII_KEY = /email|name|address|phone|query|search|customer/i;
  var dedupeKeys = new Set();
  var lastKachingSelection = null;
  var engaged = false;
  var pageStart = Date.now();
  var bounceDone = false;
  var productViewed = false;
  var checkoutStarted = false;
  var cartOpen = false;
  var impressedDeals = new Set();
  var requestCounter = 0;
  var fetchWrapped = false;

  function commonProps() {
    return {
      page_type: (document.body && document.body.dataset.pageType) || '',
      path: location.pathname,
      currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || '',
      viewport_width: window.innerWidth,
      device_class: window.innerWidth < 750 ? 'mobile' : 'desktop'
    };
  }

  function scrub(properties) {
    var out = {};
    if (!properties || typeof properties !== 'object') return out;
    Object.keys(properties).forEach(function (key) {
      if (PII_KEY.test(key)) return;
      var value = properties[key];
      if (value == null) return;
      if (typeof value === 'string' && /@/.test(value)) return;
      out[key] = value;
    });
    return out;
  }

  function isPosthogReady() {
    if (window.__runitPosthogLoaded !== true) return false;
    if (!window.posthog || typeof window.posthog.capture !== 'function') return false;
    if (
      typeof window.posthog.has_opted_out_capturing === 'function' &&
      window.posthog.has_opted_out_capturing()
    ) {
      return false;
    }
    return true;
  }

  function capture(name, properties, dedupeKey) {
    try {
      if (!isPosthogReady()) return;
      if (dedupeKey) {
        if (dedupeKeys.has(dedupeKey)) return;
        dedupeKeys.add(dedupeKey);
      }
      var payload = Object.assign({}, commonProps(), scrub(properties));
      window.posthog.capture(String(name), payload);
    } catch (e) {
      /* analytics must never throw into commerce */
    }
  }

  function getLastKachingSelection() {
    return lastKachingSelection;
  }

  function resetForNavigation() {
    dedupeKeys = new Set();
    lastKachingSelection = null;
    engaged = false;
    pageStart = Date.now();
    bounceDone = false;
    productViewed = false;
    checkoutStarted = false;
    cartOpen = false;
    impressedDeals = new Set();
  }

  window.RunItAnalytics = Object.freeze({
    capture: capture,
    getLastKachingSelection: getLastKachingSelection,
    resetForNavigation: resetForNavigation
  });

  function markEngaged() {
    engaged = true;
  }

  function resolveCtaType(el) {
    if (!el || !el.closest) return 'button';
    if (
      el.matches('[name="add"], button[name="add"], .product-form__submit') ||
      (el.closest('form[action*="/cart/add"]') &&
        el.matches('button, input[type="submit"], [role="button"]'))
    ) {
      return 'add_to_cart';
    }
    if (
      el.matches('[name="checkout"], button[name="checkout"], a[href*="/checkout"]') ||
      (el.closest('form[action*="/checkout"]') && el.matches('button, input[type="submit"]'))
    ) {
      return 'checkout';
    }
    if (el.matches('a[href*="/cart"]')) return 'cart';
    if (el.matches('input[type="submit"], button[type="submit"]')) return 'form_submit';
    if (el.tagName === 'A') return 'link';
    return 'button';
  }

  function formType(form) {
    var action = (form.getAttribute('action') || '').toLowerCase();
    if (action.indexOf('/cart/add') !== -1) return 'add_to_cart';
    if (action.indexOf('/cart') !== -1) return 'cart';
    if (action.indexOf('/contact') !== -1) return 'contact';
    if (action.indexOf('/search') !== -1) return 'search';
    if (action.indexOf('/localization') !== -1) return 'localization';
    if (form.querySelector('input[type="email"]')) return 'newsletter';
    var id = form.getAttribute('id') || form.getAttribute('name') || '';
    if (id) return 'named_form';
    return 'general_form';
  }

  function formActionPath(form) {
    try {
      var action = form.getAttribute('action') || '';
      if (!action) return location.pathname;
      var url = new URL(action, location.origin);
      return url.pathname;
    } catch (e) {
      return '';
    }
  }

  function normalizeCartItems(payload) {
    var rows = [];
    if (!payload) return rows;
    if (Array.isArray(payload.items)) rows = payload.items;
    else if (Array.isArray(payload)) rows = payload;
    else if (payload.variant_id || payload.id) rows = [payload];
    return rows.map(function (item) {
      return scrub({
        product_id: item.product_id,
        variant_id: item.variant_id || item.id,
        quantity: item.quantity,
        price: item.final_price != null ? item.final_price : item.price,
        sku: item.sku || undefined
      });
    });
  }

  function readCartCount() {
    var el = document.querySelector(
      '#cart-icon-bubble .cart-count-bubble span[aria-hidden="true"], #cart-icon-bubble .cart-count-bubble span, [data-cart-count]'
    );
    if (!el) return null;
    var n = parseInt(String(el.textContent || '').replace(/[^\d]/g, ''), 10);
    return Number.isFinite(n) ? n : null;
  }

  function isCartAddUrl(input) {
    try {
      var raw = typeof input === 'string' ? input : input && input.url;
      if (!raw) return false;
      var url = new URL(raw, location.origin);
      if (url.origin !== location.origin) return false;
      return /\/cart\/add\.js$/i.test(url.pathname);
    } catch (e) {
      return false;
    }
  }

  function wrapFetchOnce() {
    if (fetchWrapped || typeof window.fetch !== 'function') return;
    fetchWrapped = true;
    var originalFetch = window.fetch;
    window.fetch = function () {
      var args = arguments;
      var input = args[0];
      var observe = isCartAddUrl(input);
      var requestId = null;
      var itemCountBefore = null;
      if (observe) {
        requestCounter += 1;
        requestId = String(requestCounter) + '-' + String(Date.now());
        itemCountBefore = readCartCount();
      }
      var result = originalFetch.apply(this, args);
      if (!observe) return result;
      return result.then(function (response) {
        try {
          if (response && response.ok && typeof response.clone === 'function') {
            response
              .clone()
              .json()
              .then(function (payload) {
                var items = normalizeCartItems(payload);
                var addedQty = items.reduce(function (sum, item) {
                  return sum + (Number(item.quantity) || 0);
                }, 0);
                var itemCountAfter =
                  itemCountBefore == null ? null : itemCountBefore + addedQty;
                document.dispatchEvent(
                  new CustomEvent('runit:cart-add-success', {
                    detail: {
                      requestId: requestId,
                      items: items,
                      itemCountBefore: itemCountBefore,
                      itemCountAfter: itemCountAfter
                    }
                  })
                );
              })
              .catch(function () {
                /* ignore non-json cart responses */
              });
          }
        } catch (e) {
          /* never break add-to-cart */
        }
        return response;
      });
    };
  }

  function maybeProductViewed() {
    if (productViewed) return;
    if (!document.body || document.body.dataset.pageType !== 'product') return;
    if (!isPosthogReady()) return;
    productViewed = true;
    var productId =
      (window.meta && window.meta.product && window.meta.product.id) ||
      (document.querySelector('[data-product-id]') &&
        document.querySelector('[data-product-id]').getAttribute('data-product-id')) ||
      null;
    capture(
      'product_viewed',
      { product_id: productId },
      'product_viewed:' + location.pathname
    );
  }

  function bindKachingBlock(block) {
    if (!block || block.dataset.runitKachingBound === 'true') return;
    block.dataset.runitKachingBound = 'true';

    function dealIdFrom(detail, fallback) {
      if (!detail || typeof detail !== 'object') return fallback || 'unknown';
      return (
        detail.dealId ||
        detail.deal_id ||
        detail.id ||
        detail.dealBarId ||
        detail.deal_bar_id ||
        fallback ||
        'unknown'
      );
    }

    function selectedVariantIds(detail) {
      if (!detail || typeof detail !== 'object') return [];
      var raw =
        detail.variantIds ||
        detail.variant_ids ||
        detail.selectedVariantIds ||
        detail.variants ||
        [];
      if (!Array.isArray(raw)) return [];
      return raw
        .map(function (entry) {
          if (entry && typeof entry === 'object') return entry.id || entry.variant_id;
          return entry;
        })
        .filter(Boolean);
    }

    function onDealBarSelected(event) {
      try {
        var detail = event && event.detail;
        var dealId = dealIdFrom(detail, block.getAttribute('data-deal-id'));
        lastKachingSelection = {
          dealId: dealId,
          variantIds: selectedVariantIds(detail),
          source: 'deal-bar-selected'
        };
        capture('kaching_offer_clicked', {
          deal_id: dealId,
          variant_ids: lastKachingSelection.variantIds,
          interaction: 'deal_bar'
        });
      } catch (e) {
        /* ignore */
      }
    }

    function onVariantSelected(event) {
      try {
        var detail = event && event.detail;
        var dealId = dealIdFrom(
          detail,
          (lastKachingSelection && lastKachingSelection.dealId) ||
            block.getAttribute('data-deal-id')
        );
        lastKachingSelection = {
          dealId: dealId,
          variantIds: selectedVariantIds(detail),
          source: 'variant-selected'
        };
        capture('kaching_offer_clicked', {
          deal_id: dealId,
          variant_ids: lastKachingSelection.variantIds,
          interaction: 'variant'
        });
      } catch (e) {
        /* ignore */
      }
    }

    function onVariantsChanged(event) {
      try {
        var detail = event && event.detail;
        if (!lastKachingSelection) {
          lastKachingSelection = {
            dealId: dealIdFrom(detail, block.getAttribute('data-deal-id')),
            variantIds: selectedVariantIds(detail),
            source: 'variants-changed'
          };
        } else {
          lastKachingSelection.variantIds = selectedVariantIds(detail);
          lastKachingSelection.source = 'variants-changed';
        }
      } catch (e) {
        /* ignore */
      }
    }

    block.addEventListener('deal-bar-selected', onDealBarSelected);
    block.addEventListener('variant-selected', onVariantSelected);
    block.addEventListener('variants-changed', onVariantsChanged);

    if (typeof IntersectionObserver === 'function') {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            var dealId =
              block.getAttribute('data-deal-id') ||
              block.getAttribute('data-dealid') ||
              block.id ||
              'kaching';
            if (impressedDeals.has(dealId)) return;
            impressedDeals.add(dealId);
            capture(
              'kaching_offer_impression',
              { deal_id: dealId },
              'kaching_impression:' + dealId
            );
            observer.disconnect();
          });
        },
        { threshold: 0.25 }
      );
      observer.observe(block);
    }
  }

  function discoverKaching() {
    var existing = document.querySelector('kaching-bundles-block');
    if (existing) {
      bindKachingBlock(existing);
      return;
    }
    if (typeof MutationObserver !== 'function') return;
    var mo = new MutationObserver(function () {
      var block = document.querySelector('kaching-bundles-block');
      if (!block) return;
      bindKachingBlock(block);
      mo.disconnect();
    });
    mo.observe(document.documentElement, { childList: true, subtree: true });
  }

  function observeCartDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof MutationObserver !== 'function') return;
    var update = function () {
      try {
        var open =
          drawer.classList.contains('active') ||
          drawer.hasAttribute('open') ||
          drawer.getAttribute('aria-hidden') === 'false';
        if (open && !cartOpen) {
          cartOpen = true;
          capture('cart_opened', {}, 'cart_opened:' + String(Date.now()));
        } else if (!open) {
          cartOpen = false;
        }
      } catch (e) {
        /* ignore */
      }
    };
    update();
    new MutationObserver(update).observe(drawer, {
      attributes: true,
      attributeFilter: ['class', 'open', 'aria-hidden']
    });
  }

  function bindListeners() {
    document.addEventListener(
      'click',
      function (event) {
        try {
          var target = event.target;
          if (!target || !target.closest) return;

          var checkoutEl = target.closest(
            'a[href*="/checkout"], button[name="checkout"], [href="/checkout"]'
          );
          if (checkoutEl && !checkoutStarted) {
            checkoutStarted = true;
            markEngaged();
            capture('checkout_started', {}, 'checkout_started');
          }

          var cta = target.closest(
            'button, input[type="button"], input[type="submit"], [role="button"], a.btn, a.button, .btn, .button'
          );
          if (cta) {
            markEngaged();
            capture('cta_clicked', { cta_type: resolveCtaType(cta) });
          }

          var link = target.closest('a[href]');
          if (link && link.href) {
            try {
              var dest = new URL(link.href, location.origin);
              if (dest.protocol.indexOf('http') === 0 && dest.hostname !== location.hostname) {
                capture('outbound_link_clicked', { destination_host: dest.hostname });
              }
            } catch (e) {
              /* ignore bad urls */
            }
          }
        } catch (e) {
          /* ignore */
        }
      },
      true
    );

    document.addEventListener(
      'submit',
      function (event) {
        try {
          var form = event.target;
          if (!form || form.tagName !== 'FORM') return;
          markEngaged();
          if ((form.getAttribute('action') || '').indexOf('/checkout') !== -1 && !checkoutStarted) {
            checkoutStarted = true;
            capture('checkout_started', {}, 'checkout_started');
          }
          capture('form_submitted', {
            form_type: formType(form),
            form_action_path: formActionPath(form)
          });
        } catch (e) {
          /* ignore */
        }
      },
      true
    );

    var scrollMarks = { 25: false, 50: false, 75: false, 90: false };
    var scrollTicking = false;
    function evaluateScroll() {
      var doc = document.documentElement;
      var body = document.body;
      var scrollTop = window.pageYOffset || doc.scrollTop || (body && body.scrollTop) || 0;
      var maxScroll =
        Math.max(doc.scrollHeight, (body && body.scrollHeight) || 0) - window.innerHeight;
      if (maxScroll <= 0) return;
      var pct = Math.min(100, Math.round((scrollTop / maxScroll) * 100));
      [25, 50, 75, 90].forEach(function (th) {
        if (pct >= th && !scrollMarks[th]) {
          scrollMarks[th] = true;
          capture(
            'scroll_depth',
            { depth_percentage: th },
            'scroll_depth:' + String(th)
          );
        }
      });
    }
    window.addEventListener(
      'scroll',
      function () {
        if (scrollTicking) return;
        scrollTicking = true;
        window.requestAnimationFrame(function () {
          evaluateScroll();
          scrollTicking = false;
        });
      },
      { passive: true }
    );

    document.addEventListener('runit:variant-change', function (event) {
      try {
        var variant = event && event.detail && event.detail.variant;
        if (!variant) return;
        capture('variant_selected', {
          variant_id: variant.id,
          product_id: variant.product_id,
          available: variant.available,
          price: variant.price
        });
      } catch (e) {
        /* ignore */
      }
    });

    document.addEventListener('runit:cart-add-success', function (event) {
      try {
        markEngaged();
        var detail = (event && event.detail) || {};
        var items = Array.isArray(detail.items) ? detail.items : [];
        var value = items.reduce(function (sum, item) {
          return sum + (Number(item.price) || 0) * (Number(item.quantity) || 0);
        }, 0);
        capture(
          'product_added_to_cart',
          {
            request_id: detail.requestId,
            items: items,
            item_count: items.length,
            quantity: items.reduce(function (sum, item) {
              return sum + (Number(item.quantity) || 0);
            }, 0),
            value: value,
            item_count_before: detail.itemCountBefore,
            item_count_after: detail.itemCountAfter,
            buy_panel: window.RLBuyPanelType || null
          },
          detail.requestId ? 'cart_add:' + detail.requestId : undefined
        );
        if (lastKachingSelection) {
          capture(
            'kaching_offer_accepted',
            {
              deal_id: lastKachingSelection.dealId,
              variant_ids: lastKachingSelection.variantIds,
              request_id: detail.requestId,
              items: items
            },
            detail.requestId ? 'kaching_accepted:' + detail.requestId : undefined
          );
          lastKachingSelection = null;
        }
      } catch (e) {
        /* ignore */
      }
    });

    window.addEventListener('pagehide', function () {
      try {
        if (bounceDone) return;
        bounceDone = true;
        var elapsed = Date.now() - pageStart;
        if (elapsed < 10000 && !engaged) {
          capture('user_bounced', {
            duration_seconds: Number((elapsed / 1000).toFixed(1))
          });
        }
      } catch (e) {
        /* ignore */
      }
    });

    document.addEventListener('runit:posthog-ready', function () {
      maybeProductViewed();
      /* Full-implementation gap fill: manual page_view (SDK runs with capture_pageview:false,
         consent-gated, SPA-safe via pages:events + resetForNavigation dedupe). */
      capture('page_view', {
        title: document.title,
        referrer: document.referrer && document.referrer.indexOf(location.origin) === 0 ? 'internal' : document.referrer
      }, 'page_view:' + location.pathname + ':' + Math.floor(Date.now() / 300000));
    });
    maybeProductViewed();
  }

  wrapFetchOnce();
  bindListeners();
  discoverKaching();
  observeCartDrawer();
})();
